import { render, staticRenderFns } from "./BvnVerification.vue?vue&type=template&id=bd75842c&scoped=true"
import script from "./BvnVerification.vue?vue&type=script&lang=js"
export * from "./BvnVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd75842c",
  null
  
)

export default component.exports